<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <bar-chart class="col-span-2 bg-white overflow-hidden shadow rounded-lg mb-4 p-4"
               :chart-data="clientsPerMonth"/>
  </div>
</template>
<script>
import ReportDatePicker from '@/views/admin/reports/ReportDatePicker'
import BarChart from '@/components/Charts/BarChart'
import ReportService from '@/services/ReportService'

export default {
  components: {
    BarChart,
    ReportDatePicker,
  },
  props: {
    dateFrom: {
      type: String,
      default: '',
    },
    dateTill: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      year: new Date().getFullYear(),
      loading: false,
      clientTotals: {
        results: []
      }
    }
  },
  computed: {
    reportParams () {
      return {
        model: 'clients',
        group: 'month,day',
        select: 'id,total',
        date_range: 'custom',
        date_from: this.dateFrom,
        date_till: this.dateTill,
        sort: 'date_month',
      }
    },
    clientsPerMonth () {
      return {
        labels: this.clientTotals.results.map(r => this.$formatDate(new Date(this.year, r.date_month - 1, 1), 'MMM')),
        datasets: [
          {
            label: this.$t('reports.registeredClients'),
            backgroundColor: '#0695A2',
            data: this.clientTotals.results.map(r => ({
              x: new Date(this.year, r.date_month - 1, 1),
              y: r.total
            }))
          },
        ]
      }
    }
  },
  methods: {
    async getReports () {
      try {
        this.loading = true
        await Promise.all([
          this.getClientReport(),
        ])
      } finally {
        this.loading = false
      }
    },
    async getClientReport () {
      const {data} = await ReportService.get(this.reportParams)
      this.clientTotals = data
    }
  },
  watch: {
    dateFrom() {
      this.getReports()
    },
    dateTill() {
      this.getReports()
    }
  },
  mounted () {
    this.getReports()
  }
}
</script>
<style>
</style>
